export default __webpack_public_path__ + "static/media/circle2Hsb.00adfba8.svg";